"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Box = _interopRequireDefault(require("../Containers/Box"));
var _LoaderContainer = _interopRequireDefault(require("../Loaders/LoaderContainer"));
var _Loader = _interopRequireDefault(require("../Loaders/Loader"));
var _mixins = require("../mixins");
var _helpers = require("../helpers");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Header = (0, _styledComponents["default"])(_Box["default"]).attrs(function (props) {
  return {
    d: "flex",
    gap: props.spacing || props.gap || "xs",
    justifyContent: props.justifyContent || "space-between"
  };
}).withConfig({
  displayName: "Table__Header",
  componentId: "sc-1a7azsb-0"
})(["padding:", ";", ";"], function (props) {
  return props.theme.layouts.p;
}, _mixins.paddingMixin);
Header.displayName = "Table.Header";
var cellMixin = (0, _styledComponents.css)(["position:relative;padding:", ";", ";", ";", ";display:table-cell;vertical-align:middle;border-bottom:1px solid ", ";text-align:left;&:first-child{padding-left:", ";}&:last-child{padding-right:", ";}", ";", ";", ";"], function (props) {
  return "".concat(props.theme.spaces.base);
}, _mixins.paddingMixin, (0, _mixins.backgroundMixin)(), (0, _mixins.colorMixin)("inherit"), function (props) {
  return props.theme.colors.border;
}, function (props) {
  return props.theme.layouts.p;
}, function (props) {
  return props.theme.layouts.p;
}, function (props) {
  return props.inputAligned && (0, _styledComponents.css)(["padding-left:calc(", " + ", ");"], props.theme.spaces.base, props.theme.fields.pH);
}, function (props) {
  return props.textAlign && (0, _styledComponents.css)(["text-align:", ";"], props.textAlign);
}, function (props) {
  return props.height && (0, _styledComponents.css)(["height:", ";"], props.height);
});
var HeadCell = _styledComponents["default"].th.withConfig({
  displayName: "Table__HeadCell",
  componentId: "sc-1a7azsb-1"
})(["", ";", ";font-weight:", ";font-size:", ";&:hover{cursor:pointer;}"], cellMixin, (0, _mixins.colorMixin)("tableHeadText"), function (props) {
  return props.theme.fontWeights.bold;
}, function (props) {
  return props.theme.tabs.fontSize;
});
HeadCell.displayName = "Table.HeadCell";
var IconContainer = _styledComponents["default"].div.withConfig({
  displayName: "Table__IconContainer",
  componentId: "sc-1a7azsb-2"
})(["display:inline;margin-left:", ";margin-right:", ";padding-right:", ";position:relative;> *{position:absolute;left:0;top:50%;transform:translateY(-50%);}"], function (props) {
  return props.theme.spaces[props.mL] || props.theme.spaces.xs;
}, function (props) {
  return props.theme.spaces[props.mR] || "0";
}, function (props) {
  return props.width || props.theme.iconSizes.s;
});
var Cell = _styledComponents["default"].td.withConfig({
  displayName: "Table__Cell",
  componentId: "sc-1a7azsb-3"
})(["", ";word-break:break-word;font-size:", ";", " &:first-child,&:last-child{&::before{content:\"\";width:", ";height:1px;position:absolute;bottom:-1px;background-color:", ";}}&:first-child::before{left:0;}&:last-child::before{right:0;}"], cellMixin, function (props) {
  return props.theme.fontSizes.base;
}, function (props) {
  return props.customWidth && (0, _styledComponents.css)(["width:", ";"], props.customWidth);
}, function (props) {
  return props.theme.spaces.m;
}, function (props) {
  return props.theme.colors.backgroundPrimary;
});
Cell.displayName = "Table.Cell";
var InputCell = (0, _styledComponents["default"])(Cell).withConfig({
  displayName: "Table__InputCell",
  componentId: "sc-1a7azsb-4"
})(["padding-top:", ";padding-bottom:", ";padding-right:0;input{color:inherit;}&:last-child{padding-right:", ";}"], function (props) {
  return props.theme.spaces.s;
}, function (props) {
  return props.theme.spaces.s;
}, function (props) {
  return props.theme.spaces.base;
});
InputCell.displayName = "Table.InputCell";
var Row = _styledComponents["default"].tr.withConfig({
  displayName: "Table__Row",
  componentId: "sc-1a7azsb-5"
})(["", ";", ";", ";&:last-child{", "::before{display:none;}}"], (0, _mixins.backgroundMixin)(), (0, _mixins.colorMixin)("text"), function (props) {
  return props.highlightHover && (0, _styledComponents.css)(["&:hover{background-color:", ";}"], props.backgroundColor ? (0, _helpers.darkenSafe)(0.1, (0, _helpers.getColor)(props, "backgroundColor", "backgroundPrimary")) : props.theme.colors.backgroundSecondary);
}, Cell);
Row.displayName = "Table.Row";
var ButtonsWrapper = (0, _styledComponents["default"])(_Box["default"]).attrs(function (props) {
  return {
    d: "flex",
    gap: props.spacing || props.gap || "xs",
    justifyContent: props.justifyContent || "flex-end"
  };
}).withConfig({
  displayName: "Table__ButtonsWrapper",
  componentId: "sc-1a7azsb-6"
})([""]);
ButtonsWrapper.displayName = "Table.ButtonsWrapper";
var Head = _styledComponents["default"].thead.withConfig({
  displayName: "Table__Head",
  componentId: "sc-1a7azsb-7"
})([""]);
Head.displayName = "Table.Head";
var FixedHeadWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Table__FixedHeadWrapper",
  componentId: "sc-1a7azsb-8"
})(["width:100%;overflow:overlay;", "{position:sticky;top:0;z-index:", ";background-color:", ";border-bottom:1px solid ", ";}"], Head, function (props) {
  return props.theme.zIndex.fixedTableHead;
}, function (props) {
  return props.theme.colors.backgroundPrimary;
}, function (props) {
  return props.theme.colors.border;
});
var Body = _styledComponents["default"].tbody.withConfig({
  displayName: "Table__Body",
  componentId: "sc-1a7azsb-9"
})(["border-bottom:1px solid ", ";"], function (props) {
  return props.theme.colors.border;
});
Body.displayName = "Table.Body";
var outsideBorderMixin = (0, _styledComponents.css)(["", " ", ":last-child ", "{border-bottom:none;}"], function (props) {
  return (0, _styledComponents.css)(["border:1px solid ", ";border-radius:", ";border-collapse:separate;"], props.theme.colors.border, props.theme.borderRadius.base);
}, Row, Cell);
var TableComponent = _styledComponents["default"].table.withConfig({
  displayName: "Table__TableComponent",
  componentId: "sc-1a7azsb-10"
})(["width:100%;margin-bottom:0;border-collapse:separate;background-color:", ";table-layout:", ";", ";", ";", ";"], function (props) {
  return props.theme.colors.backgroundPrimary;
}, function (props) {
  return props.tableLayout || "fixed";
}, function (props) {
  return (props.outsideBorder || props.fullBorders) && (0, _styledComponents.css)(["", ""], outsideBorderMixin);
}, function (props) {
  return (props.verticalBorders || props.fullBorders) && (0, _styledComponents.css)(["", ",", "{border-left:1px solid ", ";&:first-child{border-left:none;}}"], Cell, HeadCell, props.theme.colors.border);
}, function (props) {
  return props.fullBorders && (0, _styledComponents.css)(["", ",", "{&::before{display:none;}}"], Cell, HeadCell);
});
TableComponent.displayName = "Table.Table";
var Container = _styledComponents["default"].div.withConfig({
  displayName: "Table__Container",
  componentId: "sc-1a7azsb-11"
})(["width:100%;"]);
Container.displayName = "Table.Container";
var Table = function Table(props) {
  return /*#__PURE__*/_react["default"].createElement(Container, null, /*#__PURE__*/_react["default"].createElement(TableComponent, props));
};
var LoaderCell = _styledComponents["default"].td.withConfig({
  displayName: "Table__LoaderCell",
  componentId: "sc-1a7azsb-12"
})(["height:", ";position:relative;"], function (props) {
  return props.height || "150px";
});
var Loader = function Loader(_ref) {
  var colSpan = _ref.colSpan,
    height = _ref.height;
  return /*#__PURE__*/_react["default"].createElement("tfoot", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement(LoaderCell, {
    colSpan: colSpan,
    height: height
  }, /*#__PURE__*/_react["default"].createElement(_LoaderContainer["default"], {
    overlay: true
  }, /*#__PURE__*/_react["default"].createElement(_Loader["default"], null)))));
};
Loader.propTypes = {
  height: _propTypes["default"].string,
  colSpan: _propTypes["default"].number
};
Table.Head = Head;
Table.Body = Body;
Table.Row = Row;
Table.HeadCell = HeadCell;
Table.Cell = Cell;
Table.InputCell = InputCell;
Table.ButtonsWrapper = ButtonsWrapper;
Table.IconContainer = IconContainer;
Table.Header = Header;
Table.Loader = Loader;
Table.FixedHeadWrapper = FixedHeadWrapper;
var _default = Table;
exports["default"] = _default;